import {apiAxios} from './services'

export const sendLeadDetailsToServer = async (data: any, callback?: any) => {
  try {
    await apiAxios.post(
      '/slack/landing-page/leads',
      {
        fullName: data.fullName,
        workEmail: data.workEmail,
        phoneNumber: data.phoneNumber,
        countryCode: data.countryCode,
        countryName: data.countryName,
        companyName: data.companyName,
        employees: data.employees,
        urlPath: data.urlPath,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    if (callback) callback()
  } catch (error) {
    throw new Error('Something went wrong, please try again later.')
  }
}
